import { type AxiosError } from 'axios'
import useSWR, { type SWRResponse } from 'swr'

import { type CategoryHierarchyResponseDto } from '../../CategoryHierarchyResponseDto.type'

const getCategorySwrKey = (
  akeneoCode: string | null | undefined,
): string | null => {
  if (!akeneoCode) {
    return null
  }

  return `category-hierarchy-${akeneoCode}`
}

export const useCategoryHierarchyNavigationSwr = (
  akeneoCode: string | null,
): SWRResponse<CategoryHierarchyResponseDto | null, AxiosError> => {
  // The actual fetch will be added when the category hierarchy API is ready.
  const fetcher = async (): Promise<CategoryHierarchyResponseDto | null> =>
    akeneoCode ? Promise.resolve(null) : null

  return useSWR(getCategorySwrKey(akeneoCode), fetcher, {
    keepPreviousData: true,
  })
}
